
import {
    LAWYERS_BY_FILTER
  } from '../constants/types';

  export default function(state=[], action){
    switch(action.type){
      case LAWYERS_BY_FILTER:
        return action.payload
      default:
        return state
    }
  }
